import React from 'react';
import PropTypes from 'prop-types';

import TextEditor from '../TextEditor';

import './TextEditorInline.scss';

const propTypes = {

	/**
	 * Custom class name for the editor container.
	 */
	className: PropTypes.string,

	/**
	 * The id of the DOM element where the editor will be injected.
	 */
	editorDomId: PropTypes.string.isRequired,

	/**
	 * Initial content to show in editor. Can either be a JSON-serialized
	 * ProseMirror Document object or a DOM node.
	 */
	content: PropTypes.oneOfType([PropTypes.shape({}), PropTypes.instanceOf(Element)]),

	/**
	 * Flag specifying if editor is read-only.
	 */
	readOnly: PropTypes.bool,

	/**
	 * Flag specifying if input should be focused when mounted.
	 */
	autoFocus: PropTypes.bool,

	/**
	 * The text to display when there is no content.
	 */
	placeholderText: PropTypes.string,

	/**
	 * Callback for handling editor updates.
	 */
	onChange: PropTypes.func,

};

const TextEditorInline = (props) => {

	const {
		className,
		editorDomId,
		readOnly,
		...restProps
	} = props;

	const containerId = `${editorDomId}-inline`;

	const onEditorFocus = () => {

		const toolbar = document.querySelector(
			`#${containerId} .tc-text-editor-toolbar`
		);

		// Show the toolbar
		toolbar.style.display = 'flex';

	};

	const onEditorBlur = (editorView, event) => {

		const id = event.relatedTarget && event.relatedTarget.id;

		const toolbar = document.querySelector(
			`#${containerId} .tc-text-editor-toolbar`
		);

		// Ignore blur events where focus switches to the toolbar
		switch (id) {
		case `tc-icon-btn-popover-trigger-${editorDomId}-toolbar-btn-bold`:
		case `tc-icon-btn-popover-trigger-${editorDomId}-toolbar-btn-italic`:
		case `tc-icon-btn-popover-trigger-${editorDomId}-toolbar-btn-underline`:
		case `tc-icon-btn-popover-trigger-${editorDomId}-toolbar-btn-link`:

			break;

		// Otherwise, hide the toolbar
		default:

			toolbar.style.display = 'none';

		}

	};

	const onToolbarBlur = () => {

		const toolbar = document.querySelector(
			`#${containerId} .tc-text-editor-toolbar`
		);

		// Hide the toolbar
		toolbar.style.display = 'none';

	};

	return (
		<div
			id={containerId}
			className={`
				tc-text-editor-container-inline
				${readOnly ? '' : 'editable'}
				${className || ''}
			`}>
			<TextEditor
				{...restProps}
				editorDomId={editorDomId}
				className="tc-text-editor-container"
				innerClassName="tc-text-editor-body"
				toolbarClassName="tc-text-editor-toolbar"
				toolbarPosition="bottom"
				readOnly={readOnly}
				config={{
					bold: true,
					italics: true,
					underline: true,
					history: true,
					link: true,
				}}
				triggers={{
					onEditorFocus,
					onEditorBlur,
					onToolbarBlur,
				}} />
		</div>
	);

};

TextEditorInline.propTypes = propTypes;

export default TextEditorInline;
